import { RegisterExcelInfo } from '@/coreDomainsModule/entities/inputExcelInfo';
import { InputNumberInput } from '../pages/interfaces/InputField';
import { SelectYearMonthPattern } from '../pages/interfaces/UploadFile';
import { AlterableHeaderInfo, SelectYearMonthPatternInHeader, SelectYearMonthPatternInlined } from '../pages/interfaces/LinkingInput';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * RegisterExcelInfoForm -> RegisterExcelInfo
 */
export class PutExcelInputInfoAdapter {
  /**
   * adapt
   * @param headerNumber - ヘッダー行番号
   * @param useFormatType - 年月情報の取得パターン
   * @param alternateHeaderInfos - 読み替え可能なヘッダー情報
   * @param inlinedYearMonthInfo - 年月情報の取得パターン（インライン）
   * @param inHeaderYearMonthInfo - 年月情報の取得パターン（ヘッダー）
   */
  adapt = (
    headerNumber: InputNumberInput,
    useFormatType: SelectYearMonthPattern,
    alternateHeaderInfos: AlterableHeaderInfo[],
    inlinedYearMonthInfo: SelectYearMonthPatternInlined,
    inHeaderYearMonthInfo: SelectYearMonthPatternInHeader
  ): RegisterExcelInfo => {
    return {
      headerLineNumber: headerNumber.value ?? 0,
      alternateHeaderInfos: alternateHeaderInfos,
      selectYearMonthPattern: useFormatType,
      inlinedYearMonthHeaderName: useFormatType === 'Inlined' ? inlinedYearMonthInfo.headerName : undefined,
      inHeaderYearMonthInfo:
        useFormatType === 'InHeader'
          ? {
              startColumnNumber: inHeaderYearMonthInfo.startColumnNumber.raw,
              endColumnNumber: inHeaderYearMonthInfo.endColumnNumber.raw,
              start: DateService.parseStringYearMonth(inHeaderYearMonthInfo.start.raw),
              end: DateService.parseStringYearMonth(inHeaderYearMonthInfo.end.raw),
            }
          : undefined,
    };
  };
}
